import { useCallback } from "react";
import useSWR from "swr";
import axios from "axios";

const exchangeRateUrl = () => {
    return "https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json"
}

const getRate = async (currency) => {
    if (currency === "USD") return 1

    return axios
        .get(exchangeRateUrl())
        .then((res) => res?.data?.["usd"][currency.toLowerCase()])
}

export const useCurrency = (userId) => {
    const { data: user } = useSWR(userId ? `/users/${userId}` : "/profile");
    const currency = user?.profile?.currency || "USD"

    const { data } = useSWR(currency, getRate, {
        dedupingInterval: 10000,
    })
    const rate = data ?? 0

    const convert = useCallback((amount) => (amount ?? 0) * rate, [rate])

    return { rate, currency, convert }
};
